import { createFileRoute } from "@tanstack/react-router";
import { categoryDisplayNames } from "shared";
import { Page } from "@/components/page";
import { restrictRoute } from "@/lib/routeBlocker";
import { CategorySpendChart } from "./insights/-components/category-charts/category-spend-chart";
import { InsightCard } from "./insights/-components/insight-card";
import { MissingReceipts } from "./insights/-components/missing-receipts/missing-receipts";
import { SpenderTable } from "./insights/-components/spender-table";
import { TotalSpendChart } from "./insights/-components/total-spend-chart";

export const Route = createFileRoute("/_authed/_org/insights")({
  beforeLoad: async ({ context }) =>
    restrictRoute(context, {
      redirect: {
        to: "/cards",
      },
      requiredRole: "viewOnlyAdmin",
    }),
  component: InsightsPage,
});

function InsightsPage() {
  return (
    <Page heading="Insights">
      <div className="mt-4 grid @3xl/page:grid-cols-2 grid-cols-1 grid-rows-subgrid gap-4 px-6 pb-6">
        <InsightCard title="Total spend by category">
          <CategorySpendChart
            selectFn={(i) => categoryDisplayNames[i.category]}
          />
        </InsightCard>

        <InsightCard title="Total spend by card">
          <CategorySpendChart selectFn={(i) => i.card?.name ?? ""} />
        </InsightCard>

        <InsightCard title="Total spend by budget">
          <CategorySpendChart selectFn={(i) => i.budget?.name ?? ""} />
        </InsightCard>

        <InsightCard title="Daily spend">
          <div className="h-48">
            <TotalSpendChart />
          </div>
        </InsightCard>

        <InsightCard title="Spend by person">
          <SpenderTable />
        </InsightCard>

        <InsightCard
          title="Transaction receipt status"
          subtitle="Only for transactions that require a receipt"
          withoutDateRange
        >
          <MissingReceipts />
        </InsightCard>
      </div>
    </Page>
  );
}
